import { render, staticRenderFns } from "./associationNewsList.vue?vue&type=template&id=4b6c6684&scoped=true&"
import script from "./associationNewsList.vue?vue&type=script&lang=js&"
export * from "./associationNewsList.vue?vue&type=script&lang=js&"
import style0 from "./associationNewsList.vue?vue&type=style&index=0&id=4b6c6684&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b6c6684",
  null
  
)

export default component.exports